function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from "./login-form.scss";
import template from "./login-form.html";

export var LoginFormComponent = {
  template: template,
  styles: styles,
  bindings: {},
  controller: /*#__PURE__*/function () {LoginFormComponentController.$inject = ["AuthenticationNew", "NavigationStack", "$location", "$state", "$timeout", "$modelFactory", "$window", "$rootScope", "Sync"];
    function LoginFormComponentController(AuthenticationNew, NavigationStack, $location, $state, $timeout, $modelFactory, $window, $rootScope, Sync) {
      "ngInject";_classCallCheck(this, LoginFormComponentController);
      this.$location = $location;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$window = $window;
      this.$modelFactory = $modelFactory;
      this.$rootScope = $rootScope;
      this.Sync = Sync;
      this.NavigationStack = NavigationStack;
      this.AuthenticationNew = AuthenticationNew;

      this.loading = false;
      this.isErrorsVisible = false;
      this.errorMessage = '';
      this.authModel = {};
    }_createClass(LoginFormComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this = this;
        this.$timeout(function () {
          if (_this.$window.Intercom) {
            _this.$window.Intercom('shutdown');
          }
        }, 500);
      } }, { key: "onSubmit", value: function onSubmit(

      e) {var _this2 = this;
        this.loading = true;
        this.AuthenticationNew.login(this.authModel.email, this.authModel.password).
        then(function (res) {
          console.warn('login ok', res);

          if (!_this2.Sync.initialized) _this2.Sync._initialize();
          var url;
          if (_this2.$rootScope.redirectTo) {
            url = _this2.$rootScope.redirectTo;
            _this2.$rootScope.redirectTo = null;
          } else
          {
            url = '/';
          }
          _this2.$timeout(function () {
            _this2.NavigationStack.pop('auth', {
              url: url });

          });

        }).
        catch(function (err) {
          console.warn('login failed', err);
          _this2.isErrorsVisible = true;
          _this2.errorMessage = err.message;
        }).
        finally(function () {
          _this2.loading = false;
        });
      } }, { key: "onFacebookLoginClick", value: function onFacebookLoginClick(

      e) {var _this3 = this;
        window.FB && window.FB.login(function (res) {
          if (res.status === 'connected') {
            _this3.AuthenticationNew.facebookLogin(res.authResponse.accessToken).then(function (res) {
              console.warn('login ok', res);

            }).
            catch(function (err) {
              console.warn('login failed', err);
              _this3.isErrorsVisible = true;
              _this3.errorMessage = err.data.message;
            });
          }
        }, { scope: 'email' });
      } }, { key: "onInput", value: function onInput()

      {
        this.isErrorsVisible = false;
      } }]);return LoginFormComponentController;}() };